
// import { useNavigate } from "react-router-dom";

const endpoint = "https://apiv2.mobileartsme.com/getDTShop_Content";
export const lambda = 'https://0l3a26rip1.execute-api.eu-central-1.amazonaws.com/live/giftbox_transaction'


export const services = {
  1: {
    "id": "1",
    "name": "Mobile"
  },
  3: {
    "id": "3",
    "name": "Utilities"
  },
  4: {
    "id": "4",
    "name": "GiftCards"
  },
  7: {
    "id": "7",
    "name": "Insurance"
  },
  10: {
    "id": "10",
    "name": "Finance"
  },
  11: {
    "id": "11",
    "name": "Government"
  },
  12: {
    "id": "12",
    "name": "Education"
  },
  13: {
    "id": "13",
    "name": "eSIM"
  }
};


export const SECRET_KEY = "X,sod9@jnd93ri43_=-2@#"; // Change this to a secure key

export let products = {};

export async function FetchService(index, page) {
  const serviceId = services[index].id;
  const serviceName = services[index].name;

  if (products[serviceName] && products[serviceName].length > 0) {
    return products[serviceName];
  }

  try {
    const response = await fetch(`${endpoint}?page=${page}&serviceId=${serviceId}`);
    const data = await response.json();

    console.log(data);

    // Save the fetched data into a variable named after the service
    products[serviceName] = data;
    return data;
  } catch (error) {
    console.error(`Error fetching data for ${serviceName}:`, error);
  }
}

export async function GetProductById(serviceid, productid) {
  try {
    const response = await fetch(`https://apiv2.mobileartsme.com/getDTShop_ProductById?serviceId=${serviceid}&productId=${productid}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching data for product:`, error);
  }
}

export async function GoToCheckout(product , amount) {
  // Validate product first
  if (!product || !product.service || !product.service.id || !product.id) {
    console.error("Invalid product data");
    return;
  }

  const session = sessionStorage.getItem("gbx_data");
  const uid = getCookie("gbx_id");

  if (session && uid) { // Corrected condition
    if(amount){
      window.location.href = `/checkout?sid=${product.service.id}&pid=${product.id}&productamount=${amount}`;
    }else{
      window.location.href = `/checkout?sid=${product.service.id}&pid=${product.id}`;
    }
    return;
  } else {
    window.location.href = `/signin?sid=${product.service.id}&pid=${product.id}`;
  }
}


// Set Cookie
export function setSecureCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000)); // Set expiration in days
  const secureFlag = window.location.protocol === "https:" ? "; Secure" : "";  // Add Secure flag for HTTPS
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Strict${secureFlag};`;
}

// Get Cookie
export function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
}

export function addToFavorites(product) {
  const session = sessionStorage.getItem("gbx_data");
  const uid = getCookie("gbx_id");

  if (session && uid) {
    let userData = JSON.parse(session);

    if (!userData.user.favorites || !Array.isArray(userData.user.favorites)) {
      userData.user.favorites = [];
    }

    let favorites = userData.user.favorites;
    const existingIndex = favorites.findIndex((fav) => fav.id === product.id);

    if (existingIndex !== -1) {
      favorites.splice(existingIndex, 1);
      console.log("Product removed from favorites.");

    } else {
      favorites.push({
        id: product.id,
        name: product.name,
        image: product.image,
        prices: product.prices,
        service: product.service,
      });
      console.log("Product added to favorites.");
    }

    userData.user.favorites = favorites;
    sessionStorage.setItem("gbx_data", JSON.stringify(userData));

    // Ensure JSON format is correct before sending
    const payload = JSON.stringify({ favorites: JSON.stringify(favorites), user: uid });

    fetch(`${lambda}?action=addfavorite`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: payload,
    })
      .then((response) => response.json())
      .then((res) => console.log("Favorites updated:", res))
      .catch((error) => console.error("Error updating favorites:", error));
  } else {
    window.location.href = `/signin`;
  
  }
}




export const autoLogin = async () => {
  const uid = getCookie('gbx_id');
  const data = sessionStorage.getItem('gbx_data');

  if (uid && !data) {
    try {
      const response = await fetch(`${lambda}?action=autoLogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ uid }), // Send the token
      });

      const result = await response.json();
      console.log("Auto-login response:", result);

      if (!result.error) {
        sessionStorage.setItem("gbx_data", JSON.stringify(result));
      }
    } catch (error) {
      console.error("Error during auto-login:", error);
    }
  } else {
    console.log("User already signed in");
  }
};



export function removeCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict;`;
}